import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLangPath } from "../../hooks/langAlias";
import NoticeBoard from "../Policy/NoticeBoard";
import { useSelector } from "react-redux";
import { useCookieConsent } from "../../context/CookieConsentContext";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { colors, radii } from "../../theme/designTokens";

export default function Information({ setPolicyOpen, setPolicyName }) {
  const [dOpen, dSetOpen] = useState(false);
  const [dName] = useState("");
  const { openPreferences } = useCookieConsent();

  // functions
  const handlePolicy = (policyName) => {
    setPolicyOpen(true);
    setPolicyName(policyName);
  };

  const navigate = useNavigate();
  const lp = useLangPath();
  const handleSiteMap = async () => {
    await navigate(lp("/sitemap"));
    setTimeout(() => {
      scroll();
    }, 250);
  };

  const scroll = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: radii.md,
            bgcolor: colors.primaryLight,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 16, color: colors.primary }} />
        </Box>
        <Typography sx={{ fontWeight: 700, fontSize: 15, color: colors.ink }}>
          {translateFront("Information")}
        </Typography>
      </Box>
      <List
        dense
        sx={{
          "& .MuiListItemButton-root": {
            borderRadius: radii.md,
            "&:hover": { bgcolor: colors.primaryLight },
          },
          "& .MuiListItemText-primary": {
            color: colors.ink2,
            fontSize: 14,
          },
        }}
      >
        <ListItem disablePadding>
          <ListItemButton size="small" onClick={() => handlePolicy("about-us")}>
            <ListItemText primary={translateFront("About Us")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            size="small"
            onClick={() => handlePolicy("disclaimer")}
          >
            <ListItemText primary={translateFront("Disclaimer")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            size="small"
            onClick={() => handlePolicy("terms-and-conditions")}
          >
            <ListItemText primary={translateFront("Terms & Conditions")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton size="small">
            <ListItemText
              primary={translateFront("Shipping Policy")}
              onClick={() => handlePolicy("shipping-policy")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton size="small">
            <ListItemText
              primary={translateFront("Review Policy")}
              onClick={() => handlePolicy("review-policy")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton size="small">
            <ListItemText
              primary={translateFront("Privacy Policy")}
              onClick={() => handlePolicy("privacy-policy")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton size="small" onClick={handleSiteMap}>
            <ListItemText primary={translateFront("Site Map")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton size="small" onClick={openPreferences}>
            <ListItemText primary={translateFront("Cookie Settings")} />
          </ListItemButton>
        </ListItem>
      </List>
      <NoticeBoard dOpen={dOpen} dSetOpen={dSetOpen} dName={dName} />
    </>
  );
}
